import { render, staticRenderFns } from "./PlaceUserDelete.vue?vue&type=template&id=25dc93d2&"
import script from "./PlaceUserDelete.vue?vue&type=script&lang=js&"
export * from "./PlaceUserDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports